var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center text-center mr-4",attrs:{"width":"60"}},[_c('v-img',{attrs:{"src":_vm.getSrc(_vm.id),"max-width":"60","alt":_vm.caption}}),_c('p',{staticClass:"text-body-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.caption)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }